import styled, { css } from 'styled-components';

export const IconControlContainer = styled.div<{ active?: boolean }>`
  ${({ active = false }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 5px;
    background: ${active ? 'rgba(255, 255, 255, 0.3)' : 'none'};
    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
    &:active {
      background: rgba(255, 255, 255, 0.5);
    }
  `}
`;

export const IconLoaderContainer = styled.div`
  ${() => css`
    display: flex;
    cursor: default;
    align-items: center;
    justify-content: center;
    background: none;
  `}
`;
